module.exports = __webpack_public_path__ + "assets/img/5q.0f237296.png";